import React from "react";

import MoreHorizIcon from "@mui/icons-material/MoreHoriz";

import IconButton from "@src/sharedComponents/IconButton/IconButton";
import Menu from "@src/sharedComponents/Menu/Menu";
import { MenuOption } from "@src/sharedComponents/Menu/MenuOption";
import Text from "@src/sharedComponents/Typography/Text";

import styles from "./TaskAttachment.module.css";

interface TaskAttachmentProps {
  previewUrl: string;
  filename: string;
  menuOptions?: MenuOption[];
}

const TaskAttachment: React.FC<TaskAttachmentProps> = ({
  previewUrl,
  filename,
  menuOptions,
}) => {
  return (
    <div className={styles.row}>
      <a href={previewUrl} target="_blank" rel="noopener noreferrer">
        <Text variant="body">{filename}</Text>
      </a>

      {menuOptions?.length && (
        <Menu options={menuOptions}>
          {({ handleOpenMenu }) => (
            <IconButton
              size="small"
              iconClassName={styles.attachmentMenuIcon}
              onClick={handleOpenMenu}
              IconComponent={MoreHorizIcon}
            />
          )}
        </Menu>
      )}
    </div>
  );
};

export default TaskAttachment;
